import * as React from "react"
import {AnalyticsThemeProvider} from "@ui-seeker/app";

import overrideComponents from "./overrides";
import {dipiPalette} from "./palette";

export default function AppTheme({ children }) {
    return <AnalyticsThemeProvider overrides={overrideComponents} palette={dipiPalette}>
        {children}
    </AnalyticsThemeProvider>
}

